import { SVGProps } from "react"
import { twMerge } from "tailwind-merge"

const IconArrowLeft = ({ className, ...props }: SVGProps<SVGSVGElement> & { className?: string }) => {
  return (
    <svg viewBox="0 0 7 10" fill="none" xmlns="http://www.w3.org/2000/svg" className={twMerge("size-4", className)} {...props}>
      <rect width="1.50147" height="7.06617" transform="matrix(0.70848 0.705731 -0.70848 0.705731 5.92444 0)" fill="currentColor" />
      <rect width="1.50292" height="7.08796" transform="matrix(-0.70848 0.705731 -0.70848 -0.705731 7 8.9209)" fill="currentColor" />
    </svg>
  )
}

export default IconArrowLeft
